import { lazy } from 'react';

// Block D — Library destination pages
export const LibraryContainersPage = lazy(() => import('@/capabilities/automation-library/pages/ContainersV2'));

export const LibraryContainerDetailPage = lazy(() =>
  import('@/capabilities/automation-library/pages/ContainerDetailPage').then((m) => ({
    default: m.LibraryContainerDetailPage ?? m.default,
  }))
);

export const LibraryTemplatesPage = lazy(() =>
  import('@/capabilities/automation-library/pages/TemplatesPage').then((m) => ({
    default: m.LibraryTemplatesPage ?? m.default,
  }))
);

export const LibraryTemplateDetailPage = lazy(() =>
  import('@/capabilities/automation-library/pages/TemplateDetailPage').then((m) => ({
    default: m.LibraryTemplateDetailPage ?? m.default,
  }))
);

export const LibraryBlocksPage = lazy(() =>
  import('@/capabilities/automation-library/pages/BlocksPage').then((m) => ({ default: m.LibraryBlocksPage ?? m.default }))
);

export const LibraryAtomsPage = lazy(() =>
  import('@/capabilities/automation-library/pages/AtomsPage').then((m) => ({ default: m.LibraryAtomsPage ?? m.default }))
);

export const LibraryBuildersPage = lazy(() =>
  import('@/capabilities/automation-library/pages/BuildersPage').then((m) => ({
    default: m.LibraryBuildersPage ?? m.default,
  }))
);

export const LibraryScriptsPage = lazy(() =>
  import('@/capabilities/automation-library/pages/ScriptsPage').then((m) => ({
    default: m.LibraryScriptsPage ?? m.default,
  }))
);

// Block E — builders. Forms are part of report building (Reports -> Forms tab);
// process authoring is Runway's step-by-step template builder.
export const FormBuilderList = lazy(() => import('@/capabilities/automation-library/pages/builders/report/forms/FormList'));

export const FormBuilderPage = lazy(() => import('@/capabilities/automation-library/pages/builders/report/forms/FormBuilderPage'));

export const ProcessBuilderList = lazy(
  () => import('@/capabilities/automation-library/pages/builders/process/ProcessList')
);

export const ProcessBuilderPage = lazy(
  () => import('@/capabilities/automation-library/pages/builders/process/ProcessBuilderPage')
);

export const ReportBuilderList = lazy(
  () => import('@/capabilities/automation-library/pages/builders/report/ReportBuilderList')
);

export const ReportBuilderPage = lazy(
  () => import('@/capabilities/automation-library/pages/builders/report/ReportBuilderPage')
);

export const RuleBuilderList = lazy(() => import('@/capabilities/automation-library/pages/builders/rule/RuleList'));

export const RuleBuilderPage = lazy(() => import('@/capabilities/automation-library/pages/builders/rule/RuleBuilderPage'));
